const popupTriggerComponent = (editor, componentOpts) => {
  const dc = editor.DomComponents;

  const popupTriggerOptions = componentOpts["popup-trigger"];
  const {
    name,
    type,
    mainAttribute,
    targetAttribute,
    displayTypeAttribute,
    closeOtherPopupsAttribute,
    sequenceAttribute,
  } = popupTriggerOptions;

  /*----------Listen to popup update----------*/
  const popupComponentOptions = componentOpts.popup;
  const popupMainAttribute = popupComponentOptions.mainAttribute;
  const popupType = popupComponentOptions.type;
  const popupSelector = `[${popupMainAttribute}="${popupType}"]`;
  const popupTriggerSelector = `[${mainAttribute}="${type}"]`;

  const getUpdatedTraitOptions = () => {
    try {
      const allPopups = editor.getWrapper().find(popupSelector);
      const allPopupsIds = allPopups
        .filter((popup) => {
          const popupId = popup.getAttributes().id;
          return popupId && popupId !== "";
        })
        .map((popup) => `#${popup.getAttributes().id}`);

      const popupTriggerTraitOpts = allPopupsIds.map((popupId) => ({
        id: popupId,
        name: popupId,
      }));
      return popupTriggerTraitOpts;
    } catch (err) {
      console.log(err);
      return [];
    }
  };
  window.getUpdatedTraitOptions = getUpdatedTraitOptions;

  const handlePopupChange = (updatedComponent) => {
    if (
      (updatedComponent &&
        (updatedComponent.is(popupType) || updatedComponent.is(type))) || // for add / update / remove for popup and popup-trigger
      !updatedComponent // for load
    ) {
      try {
        const allPopupTriggers = editor.getWrapper().find(popupTriggerSelector);
        const updatedOptions = getUpdatedTraitOptions();
        allPopupTriggers.forEach((popupTrigger) => {
          const triggerTrait = popupTrigger.getTrait(targetAttribute);
          triggerTrait.set("options", updatedOptions);
        });
      } catch (err) {
        console.log(err);
      }
    }
  };

  editor.on("load", () => handlePopupChange());
  editor.on("component:add", (updatedComponent) => {
    handlePopupChange(updatedComponent);
  });
  editor.on("component:update", (updatedComponent) => {
    handlePopupChange(updatedComponent);
  });
  editor.on("component:remove", (updatedComponent) => {
    setTimeout(() => {
      handlePopupChange(updatedComponent);
    }, 10);
  });
  /*------------------------------------------*/

  const traitOpts = [
    {
      type: "text",
      name: "id",
      label: "ID",
      placeholder: "Enter id...",
    },
    {
      type: "text",
      name: sequenceAttribute,
      label: "Sequence",
      placeholder: "Enter sequence...",
    },
    {
      type: "select",
      // options: getUpdatedTraitOptions(),
      options: [],
      name: targetAttribute,
      label: "Popup Target",
      placeholder: "Enter popup target...",
    },
    {
      type: "select",
      name: displayTypeAttribute,
      label: "Popup Display Type",
      placeholder: "Enter display type...",
      options: [
        { id: "block", name: "block" },
        { id: "inline", name: "inline" },
        { id: "inline-block", name: "inline-block" },
        { id: "flex", name: "flex" },
      ],
      default: "block",
    },
    {
      type: "select",
      name: closeOtherPopupsAttribute,
      label: "Close all other popups",
      options: [
        { id: "yes", name: "Yes" },
        { id: "no", name: "No" },
      ]
    }
  ];

  dc.addType(type, {
    isComponent: (el) =>
      el.tagName === "DIV" && el.getAttribute(mainAttribute) === type,

    model: {
      defaults: {
        tagName: "div",
        removable: true, // Can't remove it
        draggable: true, // Can't move it
        droppable: true, // Can't drop any components inside this
        copyable: true, // Disable copy/past
        resizable: true,
        attributes: {
          [mainAttribute]: type,
          "data-gjs-type": type,
          "data-gjs-name": name,
          // [targetAttribute]: "",
          [displayTypeAttribute]: "block",
          [closeOtherPopupsAttribute]: "no"
        },
        // style: style,
        traits: traitOpts,
      },
    },
  });
};

export default popupTriggerComponent;
